export default "__VITE_ASSET__tWrE8ip7__"